export const environment = {
	production: true,
	ENV: "prod",
	BASE_URL: "https://sparks-bme.idsmed.com",
	apiBaseUrl: "https://bme-prod-be.azurewebsites.net/api/v1.0",
	BE_URL: "https://bme-prod-be.azurewebsites.net/file-viewer",
	BE_BASE_URL: "https://bme-prod-be.azurewebsites.net",
	AZURE_BLOB:
		"https://saidsmseapdbespoke02.blob.core.windows.net/bespoke/BME/Installer",
	AZURE_TENANT_ID: "0c151b16-ffbf-4a6a-a0f7-419d57e793eb",
	AZURE_CLIENT_ID: "4c74bd33-912f-4ff3-b293-8ae4e3e99895",
	ASSET_PATH: "",
};

export const settings = {
	apiBaseUrl: "https://bme-prod-be.azurewebsites.net/api/v1.0",
};
